import React, { ChangeEventHandler, useRef } from "react"
import CameraButtonRow from "./CameraButtonRow"
import Theme from "../../library/Theme"

interface CameraControlsProps {
  showCameraButton: boolean
  theme: Theme
  canSwitchCamera: boolean
  switchCamera: () => void
  switchDevice: () => void
  startCapture: () => void
  handleUserSelectedImage: (file: File) => void
}

export default function CameraControls({ showCameraButton, theme, canSwitchCamera, switchCamera, switchDevice, startCapture, handleUserSelectedImage }: CameraControlsProps) {
  const fileInput = useRef<HTMLInputElement>(null)

  const showImageChooser = () => {
    if (!fileInput || !fileInput.current) {
      return
    }
    fileInput.current.click()
  }

  const handleChosenImage: ChangeEventHandler<HTMLInputElement> = (e) => {
    let file = e.target.files?.item(0) ?? null
    if (!file) {
      return
    }

    handleUserSelectedImage(file)
  }

  return (
    <>
      <input type="file"
        ref={fileInput}
        onChange={handleChosenImage}
        onClick={(event) => {
          event.currentTarget.value = ""
        }
        }
        accept="image/jpg,image/jpeg,image/png"
        hidden />

      <CameraButtonRow
        show={showCameraButton}
        canSwitchCamera={canSwitchCamera}
        theme={theme}
        startCapture={startCapture}
        switchCamera={switchCamera}
        switchDevice={switchDevice}
        chooseFile={showImageChooser}
      />
    </>
  )
}
